import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
import { estados } from "@/types/api"
import { CapacidadeComValor } from "@/types/capacidades"
import { Anulavel } from "@/types/gerais"
import { defineStore } from "pinia"

interface CapacidadeEstado {
  capacidades: CapacidadeComValor<number>[]
  estagioDaRequisicao: number
}
export const CapacidadesStore = defineStore("capacidades", {
  state: (): CapacidadeEstado => ({
    capacidades: [],
    estagioDaRequisicao: 0,
  }),
  getters: {
    buscarCapacidadePorId: (state) => {
      return (idAtributo: string) =>
        state.capacidades.find((capacidade) => capacidade.id === idAtributo)
    },
  },
  actions: {
    adicionarCapacidade(capacidade: CapacidadeComValor<string>) {
      const capacidadeComValor: CapacidadeComValor<number> = {
        id: capacidade.id,
        nomeDoAtributo: capacidade.nomeDoAtributo,
        tipoDoAtributo: "capacidade",
        tipoDoValor: capacidade.tipoDoValor,
        periodosDeConsumo: {
          aoMesmoTempo: retornarOValorSeForBooleano(
            capacidade.periodosDeConsumo["aoMesmoTempo"]
          ),
          naMesmaAtividade: retornarOValorSeForBooleano(
            capacidade.periodosDeConsumo["naMesmaAtividade"]
          ),
          naMesmaSemana: retornarOValorSeForBooleano(
            capacidade.periodosDeConsumo["naMesmaSemana"]
          ),
          noMesmoDia: retornarOValorSeForBooleano(
            capacidade.periodosDeConsumo["noMesmoDia"]
          ),
          noMesmoMes: retornarOValorSeForBooleano(
            capacidade.periodosDeConsumo["noMesmoMes"]
          ),
        },
        deletavel: true,
      }
      this.capacidades.push(capacidadeComValor)
    },
    removerCapacidade(idCapacidade: string) {
      const indexCapacidade = buscarIndex(this.capacidades, idCapacidade)
      this.capacidades.splice(indexCapacidade)
    },
    async listarCapacidades(idsAtributosPadrao?: string[]) {
      this.estagioDaRequisicao = estados.PEDENTE
      const atributos: CapacidadeComValor<number>[] = []
      const atributoRep = new AtributosRepositorio()

      try {
        const atributosResp = await atributoRep.listarTodosAtributosCapacidades({
          tipo_do_atributo: "igual.capacidade",
          id: idsAtributosPadrao
            ? "em.(" + idsAtributosPadrao.join(",") + ")"
            : undefined,
        })

        atributosResp.resultados.forEach((capacidade) => {
          const capacidadeComValor: CapacidadeComValor<number> = {
            id: capacidade.id!,
            nomeDoAtributo: capacidade.nome,
            tipoDoValor: capacidade.tipoDeValor,
            tipoDoAtributo: "capacidade",
            periodosDeConsumo: {
              aoMesmoTempo: retornarOValorSeForBooleano(
                capacidade.periodosDeConsumo!["aoMesmoTempo"]
              ),
              naMesmaAtividade: retornarOValorSeForBooleano(
                capacidade.periodosDeConsumo!["naMesmaAtividade"]
              ),
              naMesmaSemana: retornarOValorSeForBooleano(
                capacidade.periodosDeConsumo!["naMesmaSemana"]
              ),
              noMesmoDia: retornarOValorSeForBooleano(
                capacidade.periodosDeConsumo!["noMesmoDia"]
              ),
              noMesmoMes: retornarOValorSeForBooleano(
                capacidade.periodosDeConsumo!["noMesmoMes"]
              ),
            },
            deletavel: false,
          }
          atributos.push(capacidadeComValor)
        })
        this.capacidades = atributos
        this.estagioDaRequisicao = estados.SUCESSO
      } catch (erro) {
        this.estagioDaRequisicao = estados.ERRO
      }
    },
    resetarCapacidades() {
      this.$reset()
    },
  },
})

const buscarIndex = (capacidades: CapacidadeComValor<number>[], id: string) => {
  return capacidades.findIndex((cap) => cap.id === id)
}

const retornarOValorSeForBooleano = (valor: boolean | Anulavel<string>) => {
  return typeof valor === "boolean" ? null : +valor!
}
